// extracted by mini-css-extract-plugin
module.exports = {"restoreJobIcon":"JobSettingsFooter__restoreJobIcon--qy","disabled":"JobSettingsFooter__disabled--wK","restoreJob":"JobSettingsFooter__restoreJob--l4"};